import React, { useEffect, useState } from "react";
import { Navbar, Nav, NavDropdown, Container, Modal, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { loadCreditsData, logoutFunction } from "../redux/action";
import * as HeaderAuthentication from "../HeaderAuthentication";
import { ClearBtn, SearchBtn } from "../Buttons/Buttons";
import companyLogo from "../../assets/images/signin/logo-dark.png";
import profileImg from "../../assets/images/dashboard/profileImg.jpg";
import logOutImg from "../../assets/images/signin/log_out.png";
import "../../assets/css/navbar.scss";

const TopNavbar = ({ toggleSidebar }) => {
  const dispatch = useDispatch();
  const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails")) || [];
  const { getCredits } = useSelector((state) => state.data);
  const roles = signInDetails[0]?.role;

  const [modalShow, setModalShow] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [showSettingsDropdown, setShowSettingsDropdown] = useState(false);
  

  useEffect(() => {
    if (signInDetails?.length > 0) {
      dispatch(loadCreditsData(signInDetails[0]?.sbn_id, signInDetails[0]?.id));
    }
  }, [dispatch]);

  const logOutPage = () => {
    const logout_body = {
      user_id: parseInt(signInDetails[0]?.id),
      session_id: signInDetails[0]?.session_id,
    };
    const logout_post = {
      method: "POST",
      mode: "cors",
      headers: HeaderAuthentication.postAuthOfLeadMerge,
      body: JSON.stringify(logout_body),
    };
    dispatch(logoutFunction(logout_post));
  };

  const openLogoutModal = () => setModalShow(true);

  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().then(() => setIsFullScreen(true));
    } else {
      document.exitFullscreen().then(() => setIsFullScreen(false));
    }
  };

  const handleProfileToggle = () => {
    setShowProfileDropdown(!showProfileDropdown);
    setShowSettingsDropdown(false);
  };

  const handleToggle = () => {
    setShowSettingsDropdown(!showSettingsDropdown);
    setShowProfileDropdown(false);
  };

  return (
    <>
      <Navbar expand="lg" className="top-navbar shadow-sm">
        <Container fluid className="d-flex justify-content-between align-items-center">

          {/* Left Section - Sidebar Toggle + Logo */}
          <div className="d-flex align-items-center gap-3">
            <button
              onClick={toggleSidebar}
              className="btn btn-link"  
              style={{ padding: "0px" }}            
            >
              <i className="bx bx-menu" style={{ fontSize: "40px" }}></i>
            </button>
          </div>

          {/* Right Section - nav-collapse-second-div */}
          <div className="nav-collapse-second-div d-flex align-items-center gap-3">

            

            {/* Credits */}
            <p className="credits-count mb-0">
              {getCredits?.credits_aval ?? 0} credits Left
            </p>

            {/* Fullscreen */}
            <i
              className={`bx ${
                isFullScreen ? "bx-exit-fullscreen" : "bx-fullscreen"
              } fl-icon`}
              onClick={toggleFullScreen}
              style={{ cursor: "pointer", fontSize: "20px" }}
              title={isFullScreen ? "Exit Fullscreen" : "Enter Fullscreen"}
            ></i>

            {/* {["b2buser"].includes(roles?.toLowerCase()) ? (
              <div style={{ opacity: 1, cursor: "not-allowed" }}>
                <i
                  className="fa fa-gear settings-icon"
                  style={{ fontSize: "14px" }}
                />
              </div>
              ) : (
              <NavDropdown
                align="end"
                id="settings-dropdown"
                className="settingsNavDropdown"
                show={showSettingsDropdown}
                onToggle={() => {
                  setShowSettingsDropdown(!showSettingsDropdown);
                  setShowProfileDropdown(false);
                }}
                title={
                  <i
                    className="fa fa-gear settings-icon"
                    style={{ fontSize: "14px", cursor: "pointer" }}
                  />
                }
              >
                
                <>
                  <NavDropdown.Item href="/trash">
                    <i className="fa fa-edit text-muted fs-16 align-middle me-1"></i>
                    Trash
                  </NavDropdown.Item>

                  <NavDropdown.Item href="/users">
                    <i className="bx bxs-user-account text-muted fs-16 align-middle me-1"></i>
                    Users
                  </NavDropdown.Item>
                </>
                {["super_admin", "client"].includes(roles?.toLowerCase()) && (
              <NavDropdown.Item href="/upload-csv">
                <i className="bx bx-cloud-upload text-muted fs-16 align-middle me-1"></i>
                Upload CSV
              </NavDropdown.Item>
            )}

              </NavDropdown>
            )} */}

            <NavDropdown align="end" id="profileDropdown" className="settingsNavDropdown profileContent"
              show={showProfileDropdown}
              onClick={handleProfileToggle}
              style={{display:"flex", alignItems:"center"}}
              title={
                <div className="header-profile-div" style={{cursor: "pointer", display: "flex", alignItems: "center"}}>
                  <img src={profileImg} alt="Profile" style={{height: "30px", width: "30px", borderRadius: "50%", marginRight: "10px"}}/>
                  <div className="header-user-name">
                    <span>
                      {signInDetails[0]?.name} - ({roles})
                    </span>
                    <p style={{ margin: 0 }}>{signInDetails[0]?.email}</p>
                  </div>
                </div>
              }
            >
              <NavDropdown.Item href="/profile">
                <i className="fas fa-user fs-16 me-1"></i>Profile
              </NavDropdown.Item>
              <NavDropdown.Item href="/reset-password">
                <i className="fas fa-key fs-16 me-1"></i>Change Password
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={openLogoutModal}>
                <i className="fas fa-sign-out-alt fs-16 me-1"></i>Logout
              </NavDropdown.Item>
            </NavDropdown>
          </div>
        </Container>
      </Navbar>

      {/* Logout Modal */}
      <Modal show={modalShow} onHide={() => setModalShow(false)} centered>
        <Modal.Body className="text-center p-4">
          <img src={logOutImg} alt="Logout" className="logout_img mb-3" />
          <h6>Are you sure you want to log out?</h6>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <ClearBtn btnName="No, Stay" onClickEffect={() => setModalShow(false)} />
          <SearchBtn btnName="Yes, Logout" onClickEffect={logOutPage} />
        </Modal.Footer>
      </Modal>

      


    </>
  );
};

export default TopNavbar;